/**
 * Created by Andrey Popov on 06.08.26
 */

const GameAnnounceTracker = function () {
    this.load();

    connector.platform.parsePayload((data) => this.parsePayload(data));
};

GameAnnounceTracker.prototype.load = function () {
    const data = cleverapps.syncedStorage.load("game_announce_tracker") || {};

    this.from = data.from;
    this.payerTier = data.payerTier;
    this.arrived = data.arrived;
};

GameAnnounceTracker.prototype.save = function () {
    cleverapps.syncedStorage.save("game_announce_tracker", {
        from: this.from,
        payerTier: this.payerTier,
        arrived: this.arrived
    });
};

GameAnnounceTracker.prototype.reset = function () {
    this.from = undefined;
    this.payerTier = undefined;
    this.arrived = undefined;
    this.save();
};

GameAnnounceTracker.prototype.parsePayload = function (data) {
    if (!data || data.promo !== "game_announce" || !data.from || this.from === data.from) {
        return;
    }

    this.from = data.from;
    this.payerTier = data.payerTier;
    this.arrived = Date.now();
    this.save();

    const tierSuffix = this.payerTier !== undefined ? `_${this.payerTier}` : "";
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.GAME_ANNOUNCE_ARRIVE}${tierSuffix}-${this.from}`);
};

GameAnnounceTracker.prototype.isActive = function () {
    return this.arrived && Date.now() - this.arrived < cleverapps.parseInterval(GameAnnounceTracker.TRACK_DURATION);
};

GameAnnounceTracker.prototype.onPurchase = function (purchase) {
    if (!this.isActive() || this.payerTier === undefined) {
        return;
    }

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.GAME_ANNOUNCE_PAY}_${this.payerTier}_${cleverapps.paymentsHistory.classify()}`, { value: purchase.realPrice });
};

GameAnnounceTracker.TRACK_DURATION = "2 weeks";

cleverapps.InitByFeature["game_announce_tracker"] = function () {
    cleverapps.gameAnnounceTracker = new GameAnnounceTracker();

    cleverapps.eventBus.on("userChanged", () => {
        cleverapps.gameAnnounceTracker.reset();
    });

    if (connector.payments) {
        connector.payments.on("purchase", (result) => {
            if (result && result.purchase) {
                cleverapps.gameAnnounceTracker.onPurchase(result.purchase);
            }
        });
    }
};
